require('./cmLegalDisclaimer.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @commons
const CmCheckbox = require('../cmCheckbox/cmCheckbox');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

class CmLegalDisclaimer extends React.Component {
    buildDisclaimer() {
        return (
            <div>
                <div className="cm-legal-disclaimer__declaration-header">
                    <FormattedText value="brokerCM-brokerCM_termsAndConditions" />
                </div>
                <div className="cm-legal-disclaimer__declaration-wrapper">
                    <FormattedText
                        value="brokerCM-legalDisclaimerDeclaration1"
                        className="cm-legal-disclaimer__declaration"
                    />
                    <FormattedText
                        value="brokerCM-legalDisclaimerDeclaration2"
                        className="cm-legal-disclaimer__declaration"
                    />
                    <FormattedText
                        value="brokerCM-legalDisclaimerInformative"
                        className="cm-legal-disclaimer__declaration"
                    />
                </div>
            </div>
        );
    }

    render() {
        const disclaimer = this.buildDisclaimer();

        return (
            <div className="cm-legal-disclaimer">
                <CmCheckbox
                    idName="cm-legal-disclaimer-checkbox"
                    label={disclaimer}
                    onChange={this.props.onChange}
                    value={this.props.checked}
                    errorState={this.props.errorState}
                    errorMessage={formatText(
                        'brokerCM-legalDisclaimerErrorMessage',
                    )}
                />
            </div>
        );
    }
}

CmLegalDisclaimer.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    errorState: PropTypes.bool.isRequired,
};

module.exports = CmLegalDisclaimer;
